import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { SectionHttpService } from 'src/app/http/section-http.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';

@Component({
    selector: 'app-section-list',
    templateUrl: './section-list.component.html',
    styles: [],
})
export class SectionListComponent implements OnInit {
    constructor(
        private activatedRoute: ActivatedRoute,
        private modalService: NgbModal,
        private sectionHttpService: SectionHttpService,
        private router: Router
    ) {}

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    searchBoxControl = new FormControl();

    @ViewChild('table') table: DatatableComponent;

    @ViewChild(AlertComponent) alert: AlertComponent;

    ngOnInit(): void {
        this.routeData();
        this.routeHistory();
    }

    routeHistory() {
        if (history.state.hasState) {
            setTimeout(() => {
                this.alert.addAlert({ type: history.state.type, message: history.state.message });
            });
        }
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data;
            this.tempItems = data.data;
        });
    }

    tableFiltring(event: any) {
        const val = event.target.value.toLowerCase();
        const temp = this.tempItems.filter(function (d) {
            return d.sectionName.toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.items = temp;
        this.table.offset = 0;
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this content item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    confirmTogglePublish(item: any, value: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = `${value ? 'Publish' : 'Unpublish'}`;
        confirm.componentInstance.messageLabel = `Are you sure you want to ${value ? 'publish' : 'unpublish'}  this item?`;
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.togglePublish(item, value);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.sectionHttpService.deleteSection(item.sectionId).subscribe(() => {
            this.deleteItem(item.sectionId);
            this.alert.addAlert({ type: 'success', message: 'Section Deleted successfully' });
        });
    }

    togglePublish(item: any, value: any) {
        this.sectionHttpService.togglePublishSection(item.sectionId, value).subscribe(() => {
            this.togglePublishItem(item.sectionId, value);
            this.alert.addAlert({ type: 'success', message: `Section ${value ? 'publish' : 'unPublish'} successfully` });
        });
    }

    deleteItem(itemId: any) {
        this.tempItems = this.tempItems.filter((c) => c.sectionId != itemId);
        this.items = this.tempItems;
    }

    togglePublishItem(itemId: any, value: any) {
        let item = this.tempItems.find((c) => c.sectionId === itemId);
        item.isPublished = value;
        this.items = this.tempItems;
    }
}
